const SVGComponent = (props) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_16080_64720)">
      <path
        d="M12.7288 10.9559C15.0024 10.4031 17.567 11.7193 18.4544 14.9045C18.7138 15.8357 17.9285 16.6666 16.9619 16.6666H14.1669M8.7503 5.83325C8.7503 7.21396 7.63101 8.33325 6.2503 8.33325C4.86959 8.33325 3.7503 7.21396 3.7503 5.83325C3.7503 4.45254 4.86959 3.33325 6.2503 3.33325C7.63101 3.33325 8.7503 4.45254 8.7503 5.83325ZM16.2503 5.83325C16.2503 7.21396 15.131 8.33325 13.7503 8.33325C12.3696 8.33325 11.2503 7.21396 11.2503 5.83325C11.2503 4.45254 12.3696 3.33325 13.7503 3.33325C15.131 3.33325 16.2503 4.45254 16.2503 5.83325ZM9.46201 16.6666H3.03858C2.07196 16.6666 1.28707 15.8329 1.54682 14.9018C3.06022 9.47707 9.44038 9.47707 10.9538 14.9018C11.2135 15.8329 10.4286 16.6666 9.46201 16.6666Z"
        stroke="#225AEA"
        strokeWidth={1.66667}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_16080_64720">
        <rect width={20} height={20} fill="white" />
      </clipPath>
    </defs>
  </svg>
)
export default SVGComponent
